export enum ApprovalRequestView {
    MY_REQUEST = 'my-requests', 
    MANAGE_REQUEST = 'request-for-approvals',
    HR = 'management-requests',
}